<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card grid-list-md>
      <ModelTitle title="Edit Class" @close="close()" />
      <v-card-text>
        <v-row>
         
          <v-col cols="12" sm="12">
            <v-autocomplete dense autofocus hide-details :items="Classes" clearable item-text="name"
              v-model="selectedClass" return-object label="Select Department" outlined><template slot="item"
                slot-scope="{ item }">
                <span>{{ item.name }}</span>

              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="12">
            <v-text-field outlined :hide-details="nameErrors.length === 0" dense :error-messages="nameErrors"
              v-model="ClassRoom.name" label="Name"></v-text-field>
          </v-col>


          <v-col cols="12" sm="12">
            <v-textarea outlined dense hide-details auto-grow v-model="ClassRoom.description"
              :label="$t('labels.description')"></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <v-btn color="accent" :loading="loading" dark @click="submit()">Update</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import classRoomService from "../service.js";
import classesService from "@/modules/Classes/service.js";


const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default {
  props: {
    editDialog: {
      default: false,
    },
    editClassRoom: {
      type: Object,
    },
  },
  name: "update-Class-room",
  data() {
    return {
      selectedClass: null,
      Classes: [],
      loading: false,
      dialog: false,
      ClassRoom: {
        name: null,
        classId: null,
        description: null,
      },
    };
  },
  mixins: [validationMixin],
  validations: {
    ClassRoom: {
      name: {
        required,
      },
    },
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    nameErrors() {
      const errors = [];
      if (!this.$v.ClassRoom.name.$dirty) return errors;
      if (!this.$v.ClassRoom.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));

      return errors;
    },
  },
  watch: {
    editDialog(val) {
      this.dialog = val;
    },
    dialog(val) {
      if (val) {
        this.getClasses();
      }
    },
  },
  methods: {
    getClasses() {
      return classesService.getAll().then((response) => {
        this.Classes = response.data;
        console.log("response Teacher", this.Classes);
        this.ClassRoom = JSON.parse(JSON.stringify(this.editClassRoom))
        console.log("this.ClassRoom", this.ClassRoom);
        this.Classes.map(room => {
          
          if (this.ClassRoom.ClassId === room.id) {
            console.log('room', room)
            this.selectedClass = room
          }
        })
        return response;
      });
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.ClassRoom = {
        name: null,
        classId: null,
        description: null,
      };
      this.$v.$reset();
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        this.loading = true;
        this.ClassRoom.ClassId = this.selectedClass.id
        return classRoomService
          .update(this.ClassRoom.id, this.ClassRoom)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "Class is updated",
                });
              this.loading = false;
              this.$emit("submit");
              this.close();
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
  },
};
</script>

<style scoped>
</style>
